import { Link, useLocation } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

const routeTitles = {
  "/dashboard": "Claims Dashboard",
  "/claims/search": "Claim Search",
  "/manage-users": "Manage Users",
  "/reports/logged-accepted": "Jobs Logged / Accepted",
  "/reports/qcc": "QCC Inspection Report",
};

const SEARCH_PATH = "/claims/search";

// NO modifier-click handler here, deliberately, and do not add one back.
//
// GPS asked for Ctrl+click to open the search AND move to it. It cannot be
// done: the modifier is the user telling the browser "open behind me", both
// engines honour that over anything script asks, and focus() is ignored for
// tabs as anti-focus-stealing policy. Tried through window.open and through a
// popup window; failed in Firefox and Chrome (13 Aug 2026).
//
// What DOES take focus, and is what the office now uses:
//   • Ctrl+Shift+click any link  — the browser's own focused-new-tab shortcut
//   • a plain click on the "new tab" line below (target="_blank")
//
// The handler that used to live here bailed on
// `!shiftKey && !ctrlKey && !metaKey`, so it swallowed Ctrl+SHIFT+click too and
// replaced the browser's focused tab with a backgrounded window.open. The code
// meant to deliver a focused tab was destroying the shortcut that already did.

function InfoPanel() {
  const location = useLocation();
  const title = routeTitles[location.pathname] || "Claims Dashboard";
  const onSearch = location.pathname === SEARCH_PATH;

  return (
    <div className="info-panel">
      {/* TWO LINES, TWO JOBS (Robert, 13 Aug 2026). The heading says where you
          ARE; the line under it says what you can DO — and they are now two
          separate links, because the browser forced it.

          WHY THEY ARE SEPARATE. GPS asked for the new tab to TAKE FOCUS: on a
          job, phone rings about a different job, open a tab, search, answer,
          close, back where you were. A background tab breaks that at step one.
          The first attempt intercepted Ctrl+click and re-opened through
          window.open so the tab could be focused — it does not work, in Firefox
          or Chrome, and it cannot be made to. Holding Ctrl IS the user telling
          the browser "open behind me", both engines honour that over anything
          script asks, and `focus()` is ignored for tabs outright as
          anti-focus-stealing policy (Firefox: dom.disable_window_flip).

          A plain click on target="_blank" DOES take focus, in both. So the
          action line is an ordinary anchor and the title stays an in-place
          Link. That is the same pattern medispace's needs-attention cards use,
          which is where Robert had seen it work.

          Ctrl+click on the title still opens a background tab — the browser's
          own behaviour, no longer intercepted. */}
      <Link to={SEARCH_PATH} className="text-reset text-decoration-none clickable">
        <h2>{title}</h2>
      </Link>
      {/* Shown on EVERY page including the search itself, where it means "a
          SECOND search tab" — which is the phone-call workflow exactly: you are
          already searching, a call comes in about a different job, you want
          another one without losing this one. Hiding it there was a mistake,
          and it also made the feature look broken to anyone who went looking
          for it from the search page. */}
      <a
        href={SEARCH_PATH}
        target="_blank"
        rel="noopener noreferrer"
        className="info-panel-action small text-decoration-none clickable"
        data-hint="Open Claim Search in a new tab (or Ctrl+Shift+click any link)"
      >
        <FaSearch aria-hidden="true" />
        <span>{onSearch ? "New search tab" : "Search claims — new tab"}</span>
      </a>
    </div>
  );
}

export default InfoPanel;
